import { connect } from 'react-redux';
import NavigationGridItem from '../components/NavigationGridItem';
import { getFrame, getOrientation, getThumbStatus } from '../selectors';
function mapStateToProps(state, _a) {
    var screenID = _a.screenID;
    return {
        status: getThumbStatus(state, screenID),
        frame: getFrame(state),
        orientation: getOrientation(state),
    };
}
export default connect(mapStateToProps)(NavigationGridItem);
